import { Box, Skeleton } from '@mantine/core'

import classes from './OrganisationCard.module.scss'

export function OrganisationCardSkeleton() {
  return (
    <Box className={classes.CardSkeleton} data-testid="organisation-card-skeleton">
      <Skeleton height={64} width={64} className={classes.LogoSkeleton} />
      <Skeleton height={24} width="85%" />
      <Skeleton height={20} width="75%" className={classes.TextSkeleton} />
      <Skeleton height={14} width="75%" className={classes.LinkSkeleton} />
      <Skeleton height={32} width="25%" className={classes.ButtonSkeleton} />
    </Box>
  )
}
